import React, { useState, FC } from 'react';

import { Box, Container, Divider, Grid, makeStyles } from '@material-ui/core';

import { OrderingItem } from 'kiolyn-api';

import { LayoutVariant } from '../Core/CommonTypes';

import ItemGrid from '../OrderingPage/OrderingInteraction/ItemGrid/ItemGrid';
import ItemList from '../OrderingPage/OrderingInteraction/ItemList/ItemList';
import ViewTypeSelection from '../OrderingPage/OrderingInteraction/ViewTypeSelection/ViewTypeSelection';
import ShopOrderTabs from './ShopOrderTabs';

import ShopHistory from './ShopHistory';

const useStyles = makeStyles(theme => ({
  tabs: {
    flexWrap: 'nowrap',
    height: theme.spacing(7),
    paddingTop: 4
  },
  itemGrid: {
    marginTop: theme.spacing(1)
  }
}));

interface ShopOrderingInteractionProps {
  items: OrderingItem[];
  selectItem?: (item: OrderingItem) => void;
  isItemAvailable?: (item: OrderingItem) => boolean;
  variant?: LayoutVariant;
}

const ShopOrderingInteraction: FC<ShopOrderingInteractionProps> = ({
  items,
  selectItem,
  isItemAvailable,
  variant
}: ShopOrderingInteractionProps) => {
  const classes = useStyles();
  const defaultView = 'list';

  const [state, setState] = useState({
    viewType: defaultView,
    items: items,
    tab: 0
  });

  const handleShopOrderTabChange = (tab: number) => {
    setState({ ...state, tab: tab });
  };

  const internalSelectItem = (item: OrderingItem) => {
    if (selectItem) {
      selectItem(item);
    }
  };

  const getUnavailableMessage = (item: OrderingItem) => {
    if (isItemAvailable && !isItemAvailable(item)) {
      return 'Your balance is too low to order this item';
    }

    return '';
  };

  return variant === LayoutVariant.mobile ? (
    <Box>
      <ShopOrderTabs tab={0} onTabChange={handleShopOrderTabChange} />
      <Divider></Divider>
      {state.tab === 0 ? (
        <ItemList
          items={state.items}
          onSelect={internalSelectItem}
          getUnavailableMessage={getUnavailableMessage}
          acceptOrdering={true}
        />
      ) : (
        <ShopHistory />
      )}
    </Box>
  ) : (
    <Container>
      <Grid
        container
        direction="row"
        justify="space-between"
        className={classes.tabs}
      >
        <ShopOrderTabs tab={state.tab} onTabChange={handleShopOrderTabChange} />
        {state.tab === 0 && (
          <ViewTypeSelection
            viewType={state.viewType}
            onChange={viewType => setState({ ...state, viewType })}
          />
        )}
      </Grid>
      <Divider></Divider>
      {state.tab === 0 ? (
        state.viewType === 'grid' ? (
          <Box className={classes.itemGrid}>
            <ItemGrid
              items={state.items}
              onSelect={internalSelectItem}
              getUnavailableMessage={getUnavailableMessage}
              acceptOrdering={true}
            />
          </Box>
        ) : (
          <ItemList
            items={state.items}
            onSelect={internalSelectItem}
            getUnavailableMessage={getUnavailableMessage}
            acceptOrdering={true}
          />
        )
      ) : (
        <ShopHistory />
      )}
    </Container>
  );
};

export default ShopOrderingInteraction;
